/**
 * @file: SectionLink.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A pill-shaped "label ›" link shown at the right of a section header.
 */

import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { TouchableOpacity } from 'react-native';
import { LD } from '../leadDetailKit';

export const SectionLink = ({
  label,
  onPress,
}: {
  label: string;
  onPress: () => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={onPress}
      hitSlop={{ top: 8, right: 8, bottom: 8, left: 8 }}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: rpx(6),
        paddingHorizontal: rpx(13),
        borderRadius: rpx(16),
        borderWidth: 1,
        borderColor: LD.hairline,
        backgroundColor: LD.surface,
      }}
    >
      <Typography.Text size={rpx(13)} color={LD.brand} medium>
        {label}
      </Typography.Text>
      <Icon
        name="chevron-right"
        size={rpx(14)}
        color={LD.brand}
        style={{ marginLeft: rpx(2) }}
      />
    </TouchableOpacity>
  );
};
